import React from "react";
import Button from "../ui/Button";

// Avisos del día elegido en las vistas con selector de fecha: el error de
// lectura (con Reintentar) y, en un día pasado, de dónde salen los estados.
export default function TowerDayNotice({
  error,
  onRetry,
  pastNote,
}: {
  error: string;
  onRetry: () => void;
  pastNote: string;
}) {
  return (
    <>
      {error && (
        <div className="tower-error" role="alert">
          {error}
          <Button variant="secondary" onClick={onRetry}>
            Reintentar
          </Button>
        </div>
      )}
      {pastNote && (
        <p className="tower-past-note" role="note">
          {pastNote}
        </p>
      )}
    </>
  );
}
